<template>
  <div class="betslip-bet-wrapper">
    <div class="betslip-bet"
         @click="selectBet(bet, key)"
         :class="[
           {active: key === selectedIndex && editMode && editable},
           {disabled: bettingLocked}
           ]"
         v-for="(bet, key) in ticket.bets"
         :key="key">
      <div class="bet-title">
      <span class="bet-title-outcome"
            v-for="(value, index) in bet.title"
            :key="index">
        {{value.title | translate}}
      </span>
      </div>
      <div class="bet-subtitle">
        {{bet.subtitle | translate}}
      </div>
      <div class="bet-footer">
        <div class="round-info">
          <div class="pull-left">
            <div class="label">
              {{'general_round' | translate}}
            </div>
            <div class="value">
              {{roundInfo}}
            </div>
          </div>
          <div class="pull-right">
            <div class="odd-info">
              {{getOdd(bet)}}
            </div>
          </div>
        </div>
        <div class="stake-info">
          <div>
            <div class="label">
              {{'general_stake' | translate}}
            </div>
            <div class="value" ref="myTable">
              {{bet.payment.toFixed(2)}}
            </div>
          </div>
        </div>
      </div>
      <div class="remove-bet"
           @click="removeFromBetslip(bet, $event)">
        <i class="icon icon-close"></i>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import { isArray } from 'lodash';
import eventBus from '@/utility/eventBus';

export default {
  name: 'BetslipBet',
  props: {
    bettingLocked: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      selectedIndex: null,
    };
  },
  computed: {
    ...mapGetters([
      'ticket',
      'roundInfo',
      'editMode',
      'betslipConfig',
    ]),
    editable() {
      return this.betslipConfig.editable;
    },
  },
  methods: {
    ...mapActions([
      'removeBet',
      'goToDetailBet',
    ]),
    removeFromBetslip(bet, e) {
      if (this.bettingLocked) return;
      eventBus.$emit('removeBet');
      e.stopPropagation();
      this.removeBet(bet);
    },
    selectBet(bet, key) {
      if (!this.editable || this.bettingLocked) return;
      this.selectedIndex = key;
      this.goToDetailBet(bet);
    },
    getOdd(bet) {
      if (bet.odds) {
        if (isArray(bet.odds)) {
          return bet.odds[bet.outcomes.length - 1].toFixed(2);
        }
        return bet.odds.toFixed(2);
      }
      return '';
    },
  },
};
</script>

<style lang="scss" scoped>
  .betslip-bet-wrapper {
    float: left;
    width: 100%;

    .betslip-bet {
      position: relative;
      width: 100%;
      background-color: var(--betslip-bet-bg, var(--card-bg));
      border-radius: 2px;
      padding: 10px 8px;
      line-height: 1;
      font-size: 14px;
      margin-bottom: 1px;
      float: left;
      cursor: pointer;
      border: 2px solid var(--betslip-bet-bg, var(--card-bg));
      transition: all .5s ease;

      &:hover {
        background-color: var(--card-hover-bg);
      }

      &.active {
        border: 2px solid var(--accent-bg, var(--brand-bg));
      }

      &.disabled {
        opacity: .4;
      }
    }

    .bet-title {
      float: left;
      color: var(--text-primary-1);
      margin-bottom: 8px;
      width: 95%;
      text-align: left;

      .bet-title-outcome {
        margin-right: 3px;
      }
    }

    .bet-subtitle {
      float: left;
      color: var(--accent-bg, var(--brand-bg));
      margin-bottom: 6px;
    }

    .bet-footer {
      float: left;
      width: 100%;
      border-radius: 2px;
      display: flex;
      justify-content: space-between;

      .round-info {
        border-radius: 2px 0 0 2px;
      }

      .odd-info {
        font-weight: 700;
        color: var(--text-primary-1);
      }

      .round-info, .stake-info {
        // float: left;
        padding: 8px 8px;
        background-color: var(--card-section-bg);
        text-align: left;
      }

      .round-info {
        width: 59%;
      }

      .stake-info {
        width: 40%;
      }

      .label {
        float: left;
        color: var(--text-primary-2);
      }

      .value {
        float: right;
        color: var(--text-primary-1);
        margin-left: 7px;
      }

      .stake-info {
        border-radius: 0 2px 2px 0;

        .value {
          width: 45%;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          text-align: right;
        }
      }
    }

    .remove-bet {
      position: absolute;
      right: 8px;
      top: 7px;
      color: var(--text-primary-2);
      font-size: 18px;
      cursor: pointer;
    }
  }

  @media (max-width: 661px) {
    .betslip-bet-wrapper {
      .betslip-bet {
        &:hover {
          background-color: var(--card-bg);
        }
        &:last-child {
          padding-bottom: 20px;
        }
      }
    }
  }
</style>
